import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  FirmaAvanzadaImage,
  FirmaAutografaImage,
  EFirmaImage,
} from '../../../assets/logos'
import styles from './signRequestDetailPure.module.css'

const Status = ({ status, statusColor }) => {
  return (
    <div style={{ display: 'flex' }}>
      <svg width='20' height='20'>
        <circle cx='10' cy='10' r='7' fill={statusColor} />
      </svg>
      <p style={{ margin: '0', textTransform: 'uppercase' }}>{status}</p>
    </div>
  )
}

const SignatureType = ({ signatureType, t }) => {
  let signatureImage
  let signatureName

  switch (signatureType) {
    case 1:
      signatureImage = EFirmaImage
      signatureName = t('signRequestDetail.efirma')
      break
    case 2:
      signatureImage = FirmaAvanzadaImage
      signatureName = t('signRequestDetail.fda')
      break
    case 3:
      signatureImage = FirmaAutografaImage
      signatureName = t('signRequestDetail.autograph')
      break
    default:
      break
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        style={{ width: '15px', height: '15px', margin: '0 2px' }}
        src={signatureImage}
        alt=''
      />
      <p style={{ margin: '0' }}>{signatureName}</p>
    </div>
  )
}

const IncludesMessageCertificate = ({ t }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        style={{ width: '15px', height: '15px', margin: '0 2px' }}
        src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_SIGN_REQUEST_PSC}`}
        alt=''
      />
      <p style={{ margin: '0' }}>{t('signRequestDetail.PSC')}</p>
    </div>
  )
}

const DetailItem = ({ field, fieldValue }) => {
  return (
    <div>
      <p className={styles.item_field}>{field}</p>
      <p className={styles.item_value}>{fieldValue}</p>
    </div>
  )
}

function SignRequestDetailPure({
  data,
  cancellationReason,
  includesMessageCertificate,
  showCancellationReason,
  statusColor,
  status,
  userMultipleSign,
}) {
  const { t } = useTranslation()

  const { signRequest, userRequestingSing } = data

  return (
    <section className={styles.main}>
      <div className={styles.section}>
        <DetailItem
          field={t('signRequestDetail.documentName')}
          fieldValue={signRequest?.name}
        />
        <DetailItem
          field={t('signRequestDetail.requestorName')}
          fieldValue={`${userRequestingSing?.firstName} ${userRequestingSing?.firstLastName} ${userRequestingSing?.secondLastName}`}
        />
      </div>

      <div className={styles.section_flex}>
        <p className={styles.item_field}>{t('signRequestDetail.status')}</p>
        <Status status={status} statusColor={statusColor} />
        <SignatureType signatureType={signRequest?.signatureTypeId} t={t} />
        {includesMessageCertificate && <IncludesMessageCertificate t={t} />}
      </div>

      <div className={styles.section} style={{ alignContent: 'space-between'}}>
        <DetailItem
          field={t('signRequestDetail.description')}
          fieldValue={signRequest?.comments}
        />
        {showCancellationReason && (
          <DetailItem
            field={t('newSignatureDetailView.cancellation.reason')}
            fieldValue={cancellationReason}
          />
        )}
        {userMultipleSign && (
          <p className={styles.item_field}>
            {t('signatureRequestDetailView2.instructions.details')}
          </p>
        )}
      </div>
    </section>
  )
}

export default SignRequestDetailPure
